module.exports = __webpack_public_path__ + "static/media/1f640.5ab9aaf1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f640.svg
// module id = 618
// module chunks = 1